import { NgModule } from '@angular/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabViewModule } from "primeng/tabview";
import { InstallNotificationComponent } from "./install-notification/install-notification.component";
import { MessageService } from "primeng/api";
import { InputMaskModule } from "primeng/inputmask";
import { ChipsModule } from "primeng/chips";
import { PasswordModule } from "primeng/password";
import { PolicyNotificationComponent } from "./policy-notification/policy-notification.component";
import { InputTextModule } from "primeng/inputtext";
import { FormatCurrencyPipe } from "../pipes/format-currency.pipe";
import { FormatDatePipe } from "../pipes/format-date.pipe";
import { FormatNumPipe } from "../pipes/format-num.pipe";
import { HasPermissionDirective } from "../auth/has-permission.directive";

@NgModule({
  declarations: [
    InstallNotificationComponent,
    PolicyNotificationComponent,
    FormatCurrencyPipe,
    FormatDatePipe,
    FormatNumPipe,
    HasPermissionDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    CalendarModule,
    DropdownModule,
    ToastModule,
    DialogModule,
    CheckboxModule,
    PanelMenuModule,
    MultiSelectModule,
    NgOptimizedImage,
    ChipsModule,
    PasswordModule,
    InputTextModule,
    RadioButtonModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    CalendarModule,
    DropdownModule,
    ToastModule,
    DialogModule,
    CheckboxModule,
    PanelMenuModule,
    MultiSelectModule,
    TabViewModule,
    InstallNotificationComponent,
    InputMaskModule,
    NgOptimizedImage,
    ChipsModule,
    PasswordModule,
    PolicyNotificationComponent,
    InputTextModule,
    RadioButtonModule,
    FormatCurrencyPipe,
    FormatDatePipe,
    FormatNumPipe,
    HasPermissionDirective,
  ],
  providers: [
    MessageService,
  ],
})
export class SharedModule { }
